import { RootState } from "../../app";
import { ICategorization } from "../../configMap/interfaces/category";
import { createSelector } from "@reduxjs/toolkit";
import { ConfigMap } from "../../configMap";
import {
  selectAllConfigMapCategorizations,
  selectAllCategorizationObjects,
} from "../../configMap/selectors/categorizationLinkSelectors";

const EMPTY_ARRAY: Array<ICategorization> = [];

type Props = {
  withConfig?: boolean;
};

const selectConfigMap = (state: RootState) => state.configMapReducer.configMap;

const selectWithConfig = (_: RootState, props: Props) => props.withConfig;

const selectCategorizations = createSelector(
  selectConfigMap,
  selectWithConfig,
  (
    configMap: ConfigMap | undefined,
    selectWithConfig?: boolean | undefined,
  ) => {
    if (!configMap) {
      return EMPTY_ARRAY;
    }

    if (selectWithConfig) {
      return selectAllConfigMapCategorizations(configMap);
    }

    return selectAllCategorizationObjects(configMap);
  },
);

export default selectCategorizations;
